import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { DateString, KeyValue, PayloadFastSearchKundeList, PayloadFastSearchResponse } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FastSearchService extends RestService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getSuche(searchstr: string): Observable<PayloadFastSearchResponse> {
    const params = this.getKeyValueAsQueryParams([
      {
        key: 'searchstr',
        value: searchstr
      }
    ]);

    const options = Object.assign({}, this.httpOptions, { params });
    return this.http
      .get<PayloadFastSearchResponse>(this.baseUrl + '/fastsearch/fullsearch/', options);
  }

  getKundeBirthdays(from: DateString, to: DateString, big: boolean): Observable<PayloadFastSearchKundeList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key: 'from',
        value: from
      },
      {
        key: 'to',
        value: to
      },
      {
        key: 'big',
        value: big
      }
    ]);

    const options = Object.assign({}, this.httpOptions, { params });
    return this.http
      .get<PayloadFastSearchKundeList>(this.baseUrl + '/fastsearch/kunden/birthdays', options);
  }

  searchKundeBirthdays(searchParams: KeyValue<string, any>[]): Observable<PayloadFastSearchKundeList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions, {params});
    return this.http
      .get<PayloadFastSearchKundeList>(this.baseUrl + '/fastsearch/kunden/birthdays', options);
  }

  getKundeUmkreis(lat: number, lng: number, rad: number): Observable<PayloadFastSearchKundeList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key: 'lat',
        value: lat
      },
      {
        key: 'lng',
        value: lng
      },
      {
        key: 'rad',
        value: rad
      }
    ]);
    const options = Object.assign({}, this.httpOptions, { params });
    return this.http
      .get<PayloadFastSearchKundeList>(this.baseUrl + '/fastsearch/kunden/umkreis', options);
  }
}
